'use client';

// css
import 'react-datepicker/dist/react-datepicker.css';

// libraries
import styled from 'styled-components';

interface StyledDatepickerProps {
  fullWidth?: boolean;
}

export const StyledDatepicker = styled.div<StyledDatepickerProps>`
  flex: 1 1 0%;

  & * :hover {
    cursor: pointer;
  }

  .datePickerWrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '160px')};

    height: 40px;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.23);

    box-sizing: border-box;
    background-color: var(--color-white);
    cursor: pointer;

    &:hover {
      border-color: var(--color-primary);
    }

    > label {
      > img {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        user-select: none;
        cursor: pointer;
      }
    }
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    > input {
      width: 90%;
      border: none;
      padding-left: 10px;

      &:focus,
      &:active {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }
`;
